// extracted by mini-css-extract-plugin
module.exports = {"header":"BroadcastTitle_header__30Vkd","subHeader":"BroadcastTitle_subHeader__3d-HR"};